module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-page",
    attrs: {
      "id": "expertise"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h1', {
    staticClass: "col-12 page-title"
  }, [_vm._v("\n      EXPERTISE\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row col-12 offset-xl-1 col-xl-10",
    attrs: {
      "id": "expertise-content"
    }
  }, [_c('h2', {
    staticClass: "col-12"
  }, [_vm._v("Domaines d’interventions chirurgicales")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', {
    staticClass: "col-12"
  }, [_vm._v("Domaines d’interventions médicales")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row col-12 offset-lg-2 col-lg-8",
    attrs: {
      "id": "more-info-section"
    }
  }, [_c('h2', {
    attrs: {
      "id": "more-info-title"
    }
  }, [_vm._v("EN SAVOIR PLUS...")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-2",
    attrs: {
      "id": "more-info-text"
    }
  }, [_vm._v("Pour plus d’informations concernant les chirurgies et thérapeutiques, vous pouvez retrouver et télécharger les fiches informatives à votre disposition ci-dessous :")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row",
    attrs: {
      "id": "download-file-section"
    }
  }, [_c('div', _vm._l((_vm.downloadFiles), function(downloadFile) {
    return _c('a', {
      staticClass: "download-file-item mt-1",
      attrs: {
        "href": downloadFile.location,
        "target": "_blank"
      }
    }, [_c('svg', {
      staticClass: "mr-1 bi bi-download",
      attrs: {
        "width": "1em",
        "height": "1em",
        "viewBox": "0 0 16 16",
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M.5 8a.5.5 0 01.5.5V12a1 1 0 001 1h12a1 1 0 001-1V8.5a.5.5 0 011 0V12a2 2 0 01-2 2H2a2 2 0 01-2-2V8.5A.5.5 0 01.5 8z",
        "clip-rule": "evenodd"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M5 7.5a.5.5 0 01.707 0L8 9.793 10.293 7.5a.5.5 0 11.707.707l-2.646 2.647a.5.5 0 01-.708 0L5 8.207A.5.5 0 015 7.5z",
        "clip-rule": "evenodd"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M8 1a.5.5 0 01.5.5v8a.5.5 0 01-1 0v-8A.5.5 0 018 1z",
        "clip-rule": "evenodd"
      }
    })]), _vm._v("\n              " + _vm._s(downloadFile.name) + "\n            ")])
  }), 0)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-content col-12"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._v("Les compétences de votre chirurgien regroupent :")]), _vm._v(" "), _c('ul', [_c('li', [_c('b', [_vm._v("Chirurgie implantaire")]), _vm._v(" et "), _c('b', [_vm._v("pré-implantaire")]), _vm._v(" (greffe osseuse)")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Chirurgie mucco-gingivale")]), _vm._v(" ou "), _c('b', [_vm._v("parodontale")]), _vm._v(" (greffe de gencive)")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Pose d'implants zygomatiques")])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Chirurgie pré-prothétique")]), _vm._v(" des tissus mous et durs")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Avulsions simples")]), _vm._v(", "), _c('b', [_vm._v("complexes")]), _vm._v(" des dents de sagesse, dents incluses, surnuméraires ou ectopiques ")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Chirurgie du périapex")]), _vm._v(", "), _c('b', [_vm._v("kystes")]), _vm._v(" et "), _c('b', [_vm._v("tumeurs bénignes")]), _vm._v(" des maxillaires")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Chirurgie")]), _vm._v(" à visée "), _c('b', [_vm._v("orthodontique")])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Traumatologie")]), _vm._v(" des bases maxillaires, des bases mandibulaires & alvéolo-dentaires")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Communications bucco-sinusiennes")]), _vm._v(" et "), _c('b', [_vm._v("bucco-nasales")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 horizontal-divider row"
  }, [_c('span', {
    staticClass: "col-3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-content col-12"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._v("Les compétences de votre chirurgien regroupent :")]), _vm._v(" "), _c('ul', [_c('li', [_c('b', [_vm._v("Dépistage des lésions et tumeurs")]), _vm._v(" de la cavité buccale")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Pathologies")]), _vm._v(" de l’appareil manducateur \""), _c('b', [_vm._v("DTM")]), _vm._v("\" (anciennement "), _c('b', [_vm._v("SADAM")]), _vm._v(")")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Pathologies")]), _vm._v(" des "), _c('b', [_vm._v("glandes salivaires")])]), _vm._v(" "), _c('li', [_vm._v("Prise en charge et réalisation d’"), _c('b', [_vm._v("orthèses d'avancée mandibulaire")]), _vm._v(" (Apnée du Sommeil)")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2318e91e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2318e91e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./src/views/pages/expertise/expertise.component.html
// module id = 262
// module chunks = 1